import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { extractResponseData, SmartHeader, NoRecordsCard, SmartField } from './_SmartFieldRenderer';

const CibilReportPdfOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found for the provided details. Please verify and try again." />;
    }

    const d = responseData;

    // Check all known Surepass PDF field names, then scan any string value that looks like a URL
    const pdfLink = d.pdf || d.pdf_link || d.pdf_url || d.report_url || d.download_link ||
        d.download_url || d.report_pdf || d.pdf_path || d.credit_report_pdf ||
        Object.values(d).find(
            (v) => typeof v === 'string' && (v.startsWith('http') && (v.includes('.pdf') || v.includes('pdf')))
        );

    const handleDownload = () => {
        if (pdfLink) window.open(pdfLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <SmartHeader title="CIBIL Report PDF" icon="pi-file-pdf" remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />

            <Card>
                {(d.name || d.credit_score) && (
                    <div className="grid pb-3 border-bottom-1 surface-border mb-3">
                        {d.name && <SmartField name="name" value={d.name} />}
                        {d.credit_score && <SmartField name="credit_score" value={d.credit_score} highlight />}
                    </div>
                )}

                <div className="text-center py-4">
                    <i className="pi pi-file-pdf text-5xl text-red-500 block mb-3" aria-hidden="true" />
                    <p className="text-700 text-sm m-0 mb-3">Your CIBIL credit report PDF is ready for download.</p>
                    <Button
                        label="Download CIBIL Report PDF"
                        icon="pi pi-download"
                        onClick={handleDownload}
                        disabled={!pdfLink}
                    />
                    {!pdfLink && <p className="text-500 text-xs mt-2 m-0">PDF download link not available.</p>}
                </div>
            </Card>
        </div>
    );
};

export default CibilReportPdfOutputComponent;
